package com.macrofocus.nastac.components

import com.macrofocus.nastac.DataLoader
import com.macrofocus.nastac.ViewStyle
import com.macrofocus.nastac.theme.ThemeContext
import com.macrofocus.nastac.ui.PaletteType
import emotion.react.css
import kotlinx.browser.window
import mui.icons.material.WarningAmberTwoTone
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.*
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.br
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.span
import web.cssom.*
import web.cssom.Globals.Companion.inherit
import web.cssom.LineStyle.Companion.solid
import web.html.Image

external interface IntroProps : Props {
    var dataLoader: DataLoader
}

val Introduction = FC<IntroProps> { props ->
    val UNDER_CONSTRUCTION = false

    var theme by use(ThemeContext)!!
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light

    val imageNames = listOf(
        "bnf_rob_41_scan.jpg",
        "brl_rob_22_scan.jpg",
        "brl_rob_51_scan.jpg",
        "loc_sim_1_scan.jpg",
        "rum_rob_11_scan.jpg",
        "brl_rob_22_scan.jpg",
        "rum_rob_13_scan.jpg",
        "yun_rob_15_scan.jpg"
    )

    val imagesUrls = imageNames.map { s -> url(s) }

//    val images = imageNames.map { s ->
//        val img = Image()
//        img.src = s
//        img
//    }

//    var index by useState((images.indices).random())
    val (index, setIndex) = useState(3)
    val (prevIndex, setPrevIndex) = useState<Int?>(null)

    useEffectOnce {
        imageNames.forEach { src ->
            val img = Image()
            img.src = src
        }
    }

    // Swap every 30 seconds
    useEffectOnceWithCleanup {
        val interval = window.setInterval({
            setPrevIndex(index) // remember the old index
            setIndex { prev -> (prev + 1) % imagesUrls.size }
        }, 7_000)
        onCleanup {
            window.clearInterval(interval)
        }
    }

    val viewStyleSelection = props.dataLoader.viewStyleSelection

    div {
        css {
            display = Display.flex
            justifyContent = JustifyContent.center
            /* Let it take full height */
            height = 100.vh

            /* Enable scrolling */
            overflowY = Auto.auto
        }

        Box {
            component = div
            sx {
                position = Position.absolute
                top = 0.px
                left = 0.px
                width = 100.pct
                height = 100.pct
                backgroundImage = imagesUrls[index].unsafeCast<BackgroundImage?>()
                backgroundSize = BackgroundSize.cover
                backgroundPosition = "center".unsafeCast<BackgroundPosition>()
                transition = "background-image 3s ease-in-out".unsafeCast<Transition>()
            }
        }

        Box {
            sx {
                position = Position.relative
                // So that there is no overlap with the Sidebar
                marginLeft = 330.px
                width = "calc(100vw - 330px)".unsafeCast<Width>()

                height = 100.vh
                overflow = Overflow.hidden
                display = Display.flex
                justifyContent = JustifyContent.center
                alignItems = AlignItems.center
                paddingLeft = 16.px
                paddingTop = 8.px
                paddingRight = 48.px
                paddingBottom = 16.px

                /* Use min-height instead of fixed height to allow shrinking */
                minHeight = 100.pct
                display = Display.flex
                flexDirection = FlexDirection.column
                justifyContent = JustifyContent.start
                overflowY = Auto.auto
            }

            // Foreground Card
            Card {
                sx {
                    position = Position.relative
                    maxWidth = 900.px
                    width = 100.pct
                    backgroundColor = rgb(0, 0, 0, 0.7)
                    color = NamedColor.white
    //                zIndex = 1
                    padding = 24.px
                    borderRadius = 12.px
                    overflowY = Auto.auto

                    background = rgb(255, 255, 255, 0.3)
                    backdropFilter = blur(10.px)
                    border = Border(1.px, solid, rgb(255, 255, 255, 0.4))
                    borderRadius = 16.px
                    boxShadow = BoxShadow(0.px, 4.px, 30.px, rgb(0, 0, 0, 0.2))
                    backgroundImage = linearGradient(
                        angle = 135.deg,
                        rgb(255, 255, 255, 0.4),
                        rgb(255, 255, 255, 0.1)
                    )
                    color = NamedColor.black
                    fontWeight = FontWeight.normal
                    padding = Padding(4.px, 8.px)
                    hover {
//                    background = props.tintColor?.let { Color(it).alpha(0.3) } ?: rgb(255, 255, 255, 0.3)
                        background = rgb(255, 255, 255, 0.3)
                        boxShadow = BoxShadow(0.px, 6.px, 40.px, rgb(0, 0, 0, 0.15))
                    }
                    transition = Transition(
                        property = TransitionProperty.all,
                        duration = 0.3.s,
                        timingFunction = TransitionTimingFunction.easeInOut
                    )
                }

                CardContent {
                    if(UNDER_CONSTRUCTION) {
                        Typography {
                            variant = TypographyVariant.body1
                            gutterBottom = true
                            align = TypographyAlign.center

                            sx {
                                color = NamedColor.red
                                fontWeight = "500".unsafeCast<FontWeight>()
                                lineHeight = number(0.95)
                            }

                            WarningAmberTwoTone {
                                fontSize = SvgIconSize.small
                                css {
                                    transform = "translateY(4px)".unsafeCast<Transform>()
                                }
                            }
                            +" Under Construction "
                            WarningAmberTwoTone {
                                fontSize = SvgIconSize.small
                                css {
                                    transform = "translateY(4px)".unsafeCast<Transform>()
                                }
                            }
                        }
                    }

                    Typography {
                        variant = TypographyVariant.body1
                        gutterBottom = true
                        align = TypographyAlign.justify

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.2.em
//                            color = rgb(111, 23, 25)
                            whiteSpace = WhiteSpace.preLine
                            lineHeight = number(1.6)
                        }

                        +"Welcome to the data platform of the "
                        Typography {
                            component = span

                             sx {
                                 fontFamily = "Arial, Helvetica, sans-serif;".unsafeCast<FontFamily>()
                             }
                            +"NASTAC"
                        }
                        +" (Nationalist State Transformation and Conflict) project, which culminated with the publication of the book entitled:"
                    }

                    Typography {
                        variant = TypographyVariant.h4
                        component = h1
                        gutterBottom = false

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontSize = 3.5.em
                            color = rgb(111, 23, 25)
                            fontWeight = "500".unsafeCast<FontWeight>()
                            lineHeight = number(0.95)
                        }

                        +"Nationalism"
                        span {
                            +" and the "
                            css {
                                fontSize = 0.65.em
                            }
                        }
                        br {}
                        +"Transformation"
                        span {
                            +" of the "
                            css {
                                fontSize = 0.65.em
                            }
                        }
                        +"State"
                    }

                    Typography {
                        variant = TypographyVariant.h6
                        component = h2
                        gutterBottom = true

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.5.em
                            color = rgb(99, 92, 84)
                            lineHeight = number(0.95)
                        }

                        +"Border Change and Political Violence"
                        br {}
                        +"in the Modern World"
                    }

                    Typography {
                        variant = TypographyVariant.body1
                        gutterBottom = true
                        align = TypographyAlign.justify

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.2.em
//                            color = rgb(111, 23, 25)
                            whiteSpace = WhiteSpace.preLine
                            lineHeight = number(1.6)
                        }
                        +"You will find interactive content allowing you to visually explore the data discussed in the book, as well as download the "
                        +a.create {
                            +"replication material"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.REPLICATION
                            }
                        }
                        +". "
                        +"The book can be purchased in print or downloaded for free from the "
                        a {
                            href = "https://doi.org/10.1017/9781009527767"
                            +"publisher's webpage"
                        }
                        +", Cambridge University Press."
                    }

                    if(false) {
                        Typography {
                            variant = TypographyVariant.subtitle1
                            gutterBottom = true
                            align = TypographyAlign.left

                            sx {
                                fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                                fontWeight = "500".unsafeCast<FontWeight>()
                                fontSize = 1.5.em
                                lineHeight = number(0.95)

                                color = rgb(111, 23, 25)
                                "a" {
                                    textDecoration = None.none
                                    color = inherit
                                }
                            }

                            a {
                                href = "https://icr.ethz.ch/people/cederman/"
                                +"Lars-Erik Cederman"
                            }
                            +", "
                            a {
                                href = "https://icr.ethz.ch/people/girardin/"
                                +"Luc Girardin"
                            }
                            +","
                            br {}
                            a {
                                href = "https://carl.muller-crepon.com/"
                                +"Carl Müller-Crepon"
                            }
                            span {
                                +" and "
                                css {
                                    fontSize = 0.65.em
                                    color = rgb(99, 92, 84)
                                }
                            }
                            a {
                                href = "https://icr.ethz.ch/people/pengl/"
                                +"Yannick Pengl"
                            }
                        }
                    }

                    Typography {
                        variant = TypographyVariant.body1
                        gutterBottom = true
                        align = TypographyAlign.justify

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.2.em
//                            color = rgb(111, 23, 25)
                            whiteSpace = WhiteSpace.preLine
                            lineHeight = number(1.6)
                        }
                        +"Arguing that "
                        +a.create {
                            +"the return of geopolitics"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.GEOPOLITICS
                            }
                        }
                        +", ushered in by Russia’s annexation of Crimea in 2014 and including recent warring in Ukraine and the Middle East, is driven by nationalism, this book challenges conventional approaches that ignore border change. We focus on how nationalism transforms the state."
                    }

                    Typography {
                        variant = TypographyVariant.body1
                        gutterBottom = true
                        align = TypographyAlign.justify

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.2.em
//                            color = rgb(111, 23, 25)
                            whiteSpace = WhiteSpace.preLine
                            lineHeight = number(1.6)
                        }
                        +"Using "
                        +a.create {
                            +"geocoded historical maps"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.CSHAPES
                            }
                        }
                        +" covering "
                        +a.create {
                            +"state borders"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.CSHAPES
                            }
                        }
                        +" and "
                        +a.create {
                            +"ethnic groups"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.HEG
                            }
                        }
                        +" in Europe, our spatial approach shows how, since the French Revolution, nationalism caused increasing congruence between "
                        +"state and national borders and how a lack of congruence increased the risk of armed conflict."
                    }

                    Typography {
                        variant = TypographyVariant.body1
                        gutterBottom = true
                        align = TypographyAlign.justify

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.2.em
//                            color = rgb(111, 23, 25)
                            whiteSpace = WhiteSpace.preLine
                            lineHeight = number(1.6)
                        }
                        +"The work traces this macro process from "
                        +a.create {
                            +"early modern Europe"
                            onClick = {
                                viewStyleSelection.value = ViewStyle.TILLY
                            }
                        }
                        +" and widens the geographic scope to the entire world in the mid twentieth century. The analysis shows that nationalist leaders need to be taken at their word: the risk of conflict may be increased by how nationalists seeking to revive past golden ages and restore their nations’ prestige respond to incongruent borders."
                    }

                    Typography {
                        variant = TypographyVariant.subtitle1
                        gutterBottom = true
                        align = TypographyAlign.right

                        sx {
                            fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
                            fontWeight = "500".unsafeCast<FontWeight>()
                            fontSize = 1.5.em
                            lineHeight = number(0.95)

                            color = rgb(99, 92, 84)
                        }

                        a {
                            href = "https://icr.ethz.ch/people/cederman/"
                            +"Lars-Erik Cederman"
                        }
                        +", "
                        a {
                            href = "https://icr.ethz.ch/people/girardin/"
                            +"Luc Girardin"
                        }
                        +","
                        br {}
                        a {
                            href = "https://carl.muller-crepon.com/"
                            +"Carl Müller-Crepon"
                        }
                        span {
                            +" and "
                            css {
                                fontSize = 0.65.em
                            }
                        }
                        a {
                            href = "https://icr.ethz.ch/people/pengl/"
                            +"Yannick Pengl"
                        }
                    }
                }
            }
        }
    }
}